import React from 'react';
import styled from 'styled-components';
import { Pagination } from '@increasecard/typed-components';

const alignments = {
  center: 'center',
  left: 'flex-start',
  right: 'flex-end'
};

const PaginationStyled = styled(Pagination)<{ align: 'left' | 'center' | 'right' }>`
  display: flex;
  justify-content: ${({ align }) => alignments[align]};
  margin-top: 16px;
`;

type PaginatorType = {
  onSelectPage: (pageNumber: number) => void;
  pages: number;
  selected: number;
  align: 'left' | 'center' | 'right';
};

const Paginator = ({ selected, pages, onSelectPage, align }: PaginatorType) => {
  return (
    <PaginationStyled
      align={align}
      currentPage={selected}
      onSelectPage={onSelectPage}
      totalPages={pages === 0 ? 1 : pages}
    />
  );
};

export default Paginator;
